<template>
  <footer class="footer">
    <div class="content">
      <p class="has-text-centered">
        &copy; {{hostName}} {{year}} All Rights Reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      hostName: window.location.hostname,
      year: new Date().getFullYear()
    }
  }
}
</script>